import { styled } from "@mui/material";

const CustomStepIcon = styled("div")(({ theme, ownerState }) => ({
    width: 40,
    height: 40,
    border: "3px solid",
    borderColor: ownerState.active ? "#635bff" : "#e0e0e0",
    borderRadius: "50%",
    backgroundColor: "transparent",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: ownerState.active ? "#635bff" : "#999",
    fontSize: "1.2rem",
    fontWeight: "bold",
  }));

  export default CustomStepIcon;